import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import OrderDTO from "@/dto/order/OrderDTO";
import { getRealOrderOriginalId } from "@/utils/OrderUtils";
import WithPopoverTip, { getRealBuyerNickName } from "../WithPopoverTip";
import { useGlobalStore } from "@/store/hooks";
import type GlobalStore from "@/store";
import { message, Spin, Tooltip } from "antd";

interface DouDianBuyerUsernameProps {
    order: OrderDTO;

    onSearch?: () => void;
}

async function getRealBuyerNickNameIframe(
    globalStore: typeof GlobalStore,
    shopId: number,
    orderOriginalId: string,
    getTargetEl: () => HTMLElement,
) {
    return new Promise<void>((yes, no) => {
        const div = document.createElement("div");

        globalStore.DouDianSDKStore.initRealBuyerUsername({
            element: div,
            shopId,
            orderOriginalId,
            onStart: () => {
                setTimeout(() => {
                    div.querySelector("img").click();

                    div.style.display = "none";
                    const el = getTargetEl();

                    el?.appendChild(div);
                }, 16);
            },
            onSuccess: () => {
                div.style.display = "block";

                const iframe = div.querySelector("iframe") as HTMLIFrameElement;

                if (iframe) {
                    iframe.style.zIndex = "0";
                }

                yes();
            },
            onError: () => {
                no();
            },
        });
    });
}

const DouDianBuyerUsername: React.FC<DouDianBuyerUsernameProps> = observer(function (props) {
    const { order, onSearch } = props;

    const globalStore = useGlobalStore();
    /**
     * 是否显示解密组件
     */
    const [showDecrypted, setShowDecrypted] = useState(false);
    const [loading, setLoading] = useState(false);

    const orderOriginalId = getRealOrderOriginalId(order);

    // https://im.jinritemai.com/pc_seller_v2/main/workspace?selfId=78459992871&otherSideId=59977359578&fromOrder=4859069417355038442&fromGoods=
    return (
        <div>
            {showDecrypted ? (
                <Spin spinning={loading}>
                    <div id={`dd_buyer_nick-name_${order.id}`}></div>
                </Spin>
            ) : (
                <WithPopoverTip onSearch={onSearch} key="show">
                    <span>{getRealBuyerNickName(order)}</span>
                </WithPopoverTip>
            )}

            <a
                href={`https://im.jinritemai.com/pc_seller_v2/main/workspace?fromOrder=${orderOriginalId}&fromGoods=`}
                title="联系买家"
                target="_blank"
            >
                <img
                    src="//img.alicdn.com/imgextra/i1/54458674/O1CN01T5BZ6t2DwkDaDOR82_!!54458674.png"
                    alt=""
                    style={{ width: 16, height: 16 }}
                />
            </a>

            {showDecrypted ? null : (
                <Tooltip title="点击可查看真实买家昵称；高级版支持打印抖店真实买家昵称，标准版不支持打印，如需升级，点击右上角升级去操作">
                    <span
                        className="text-gray"
                        onClick={async () => {
                            setLoading(true);
                            setShowDecrypted(true);

                            try {
                                await getRealBuyerNickNameIframe(globalStore, order.shopId, orderOriginalId, () => {
                                    return document.getElementById(`dd_buyer_nick-name_${order.id}`);
                                });
                            } catch (error) {
                                setShowDecrypted(false);

                                message.error("解密失败");
                            } finally {
                                setLoading(false);
                            }
                        }}
                    >
                        查看
                    </span>
                </Tooltip>
            )}
        </div>
    );
});

export default DouDianBuyerUsername;
